// this reducer is used to store whether an item was visited
// could probably be replaced with local storage hooks

import {createSlice} from '@reduxjs/toolkit';
import {mmkvStorage} from '../../Utils/mmkvStorage';

const initialState = {
  hasPressedBarHunt: false,
  hasPressedScavaHunt: false,
  hasViewedPassport: false,
  hasViewedTutorial: false,
  hasFinishedTutorial: false,
};

const firstVisitSlice = createSlice({
  name: 'firstVisit',
  initialState,
  reducers: {
    setFirstVisitItems(state, {payload}) {
      const newState = {...state, ...payload.items};
      mmkvStorage.set('firstVisit', JSON.stringify(newState));
      return newState;
    },
    markItemVisited(state, {payload: item}) {
      const newState = {...state, [item]: true};
      console.log('markItemVisited', {newState});
      mmkvStorage.set('firstVisit', JSON.stringify(newState));
      return newState;
    },
  },
});

export const {setFirstVisitItems, markItemVisited} = firstVisitSlice.actions;
export default firstVisitSlice.reducer;
